export default __webpack_public_path__ + "static/media/qualifiedIcon.4ba9c07f.svg";